import React from 'react';
import { Helmet } from 'react-helmet-async';

interface OpenGraphInterface {
  title?: string;
  type?: string;
  url?: string;
  imageUrl?: string;
  description?: string;
  originalUrl?: string;
}

const OpenGraphMetaTags = ({
  title,
  type,
  url,
  imageUrl,
  description,
  originalUrl,
}: OpenGraphInterface) => (
  <Helmet>
    {title && <title>{title}</title>}
    {title && <meta content={title} property="og:title" />}
    {type && <meta content={type} property="og:type" />}
    {url && <meta content={url} property="og:url" />}
    {imageUrl && <meta content={imageUrl} property="og:image" />}
    {originalUrl && <meta content={originalUrl} property="og:image" />}
    {description && <meta content={description} property="og:description" />}
  </Helmet>
);

export { OpenGraphMetaTags };
